"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _stream = _interopRequireDefault(require("../util/stream")); // TODO: multiple listeners can consume the same message. Modify this so a message can only be processed by a single listener?


var listener = function listener(frame) {
  return function () {
    return {
      listen: function listen(matcher) {
        var _ref = (0, _stream.default)(),
            reader = _ref.reader,
            writer = _ref.writer;

        frame.hear(matcher, function (response) {
          writer.send(response);
        });
        return reader;
      }
    };
  };
};

var _default = listener;
exports.default = _default;